/* eslint-disable sort-keys */
import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers([
  'container',
  'iframe',
  'iframeWrapper',
  'htmlContent',
  'loading',
  'error',
  'errorContainer',
  'separator'
]);

export const embedPanelStyles = helpers.defineMultiStyleConfig({
  /**
   * @param {Object} args - Component arguments
   * @param {Contentful.EmbedPanel} args.component - EmbedPanel component data
   * @param {boolean} [args.isComplete] - Whether component has all fields
   * @param {boolean} [args.isFetching] - Whether additional data is being fetched
   *
   * @returns {Object} - Component styles
   */
  baseStyle: ({component: {width, height, mobileHeightIframe}}) => {
    return {
      container: {
        maxWidth: '1440px',
        padding: {base: '32px 20px', lg: '48px 80px'},
        position: 'relative',
        marginX: 'auto',
        width: '100%',
      },
      iframeWrapper: {
        height: {base: mobileHeightIframe || height || '800px', lg: height || '800px'},
        position: 'relative',
        marginX: 'auto',
        width: {base: '100%', lg: width || 'auto'},
      },
      iframe: {
        border: 'none',
        display: 'block',
        height: '100%',
        maxWidth: '100%',
        width: '100%',
      },
      htmlContent: {
        height: '100%',
        width: '100%',
      },
      loading: {
        bg: 'gray.50',
        zIndex: 1,
      },
      error: {
        bg: 'gray.50',
        borderColor: 'gray.200',
        borderRadius: 'md',
        borderWidth: '1px',
      },
      errorContainer: {
        height: 'auto',
        maxWidth: '100%',
        position: 'relative',
        width: width || 'auto',
        marginY: 10,
        marginX: 'auto',
      },
      separator: {
        borderColor: 'brandColors.greyscale10',
        borderStyle: 'solid',
        mb: 8,
        opacity: 1,
      },
    };
  },
});
